export class UuidUtils {
  public static generateV4Uuid(): string {
    return crypto.randomUUID();
  }
}
